export default {
  name: "tickets",
  paidTicketStore: "paidTickets",
  offlineTicketStore: "offlineTickets",
  keyPath: "ticketItemNumber",
  version: 1 
};
